import { render } from "./edit_customer_acc_component.vue?vue&type=template&id=98ccad3e&scoped=true"
import script from "./edit_customer_acc_component.vue?vue&type=script&lang=js"
export * from "./edit_customer_acc_component.vue?vue&type=script&lang=js"

import "./edit_customer_acc_component.vue?vue&type=style&index=0&id=98ccad3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ccad3e"]])

export default __exports__